import { graphql, useStaticQuery } from 'gatsby';
import { use, useMemo } from 'react';

import { SiteContext } from 'src/context/site-context';
import { findCmsFileNodeForClub, parseRelativeDirectory } from 'src/helpers/cms-file-helper';

type CrossClubSharedSummary = {
  comingSoonClubFinder: boolean;
  statusClubFinder?: string | null;
  clubThumbnailImage: string;
  clubLocation: { text1: string | null; text2: string | null };
  phoneNumbers: { nonMembersPhoneNumber: string };
};

export const useCrossClubSharedSummary = (clubId: string): CrossClubSharedSummary => {
  const { language } = use(SiteContext);

  const data = useStaticQuery<Queries.CrossClubSharedSummaryQuery>(graphql`
    query CrossClubSharedSummary {
      newSharedContent: allFile(filter: { base: { eq: "new-shared.json" } }) {
        nodes {
          relativeDirectory
          childClubJson {
            comingSoonClubFinder
            statusClubFinder
            clubThumbnailImage
            clubLocation {
              text1
              text2
            }
            phoneNumbers {
              nonMembersPhoneNumber
            }
          }
        }
      }
    }
  `);

  return useMemo(() => {
    data.newSharedContent.nodes.forEach(parseRelativeDirectory);
    const node = findCmsFileNodeForClub(data.newSharedContent.nodes, clubId, language);
    return node!.childClubJson! as CrossClubSharedSummary;
  }, [clubId, data, language]);
};
